import { apiClient } from './apiClient';
import { apiGuestClient } from './apiGuestClient';
import { IBusDangKyXeRequest } from '../models/response/bus/IBusDangKyXe';

export const API_END_POINT = "bus";

export const busApi = {
    selectByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`${API_END_POINT}/dang-ky-xe/${ts_hocsinh_id}`),
};

export const busDangKyXeApi = {
    select_all: (nam_hoc: string, dm_coso_id: number) =>
        apiClient.get(`${API_END_POINT}/dang-ky-xe/nam-hoc/${nam_hoc}/co-so/${dm_coso_id}`),
    detail: (id: number) =>
        apiClient.get(`${API_END_POINT}/dang-ky-xe/detail/${id}`),
    insert: (data: IBusDangKyXeRequest) =>
        apiClient.post(`${API_END_POINT}/dang-ky-xe/insert`, data),
    update: (data: IBusDangKyXeRequest) =>
        apiClient.put(`${API_END_POINT}/dang-ky-xe/update`, data),
    delete: (id: number) =>
        apiClient.delete(`${API_END_POINT}/dang-ky-xe/delete/${id}`),
    approveOrCancel: (id: number, is_approve: boolean) =>
        apiClient.put(`${API_END_POINT}/dang-ky-xe/approve-cancel`, { id, is_approve }),
    huyDangKyXe: (data: any) =>
        apiClient.post(`${API_END_POINT}/dang-ky-xe/huy-dang-ky-xe`, data),
};

// API cho các combobox Bus
export const busHinhThucDangKyApi = {
    select_all: () => apiClient.get(`${API_END_POINT}/hinh-thuc-dang-ky`),
    select_by_id: (id: number) => apiClient.get(`${API_END_POINT}/hinh-thuc-dang-ky/${id}`),
};

export const busHinhThucDonTraApi = {
    select_all: () => apiClient.get(`${API_END_POINT}/hinh-thuc-don-tra`),
    select_by_id: (id: number) => apiClient.get(`${API_END_POINT}/hinh-thuc-don-tra/${id}`),
};

export const busLoaiDiemDonApi = {
    select_all: () => apiClient.get(`${API_END_POINT}/loai-diem-don`),
    select_by_id: (id: number) => apiClient.get(`${API_END_POINT}/loai-diem-don/${id}`),
};

export const busTrangThaiDangKyApi = {
    select_all: () => apiClient.get(`${API_END_POINT}/trang-thai-dang-ky`),
    select_by_id: (id: number) => apiClient.get(`${API_END_POINT}/trang-thai-dang-ky/${id}`),
};
